//This component will show  popup for filter
import "../css/Fselect.css";
import { connect } from "react-redux";
import React from "react";
import { activateDatadic, activatePath, activateDatadicbackup ,activateFiname,activateRecord,activateLoadid,activateStocks,activateChange  } from "../redux";
import axios from "axios";
import {
  Button,
  Modal,
  Typography,
  Card,
  Divider,
  Input,
  Space,
  Popconfirm,
} from "antd";
import {
  PlusOutlined,
  AudioOutlined,
  QuestionCircleOutlined,
  ExclamationCircleOutlined,
  EditOutlined,
  PlusCircleFilled,
  FilterOutlined  
  
} from "@ant-design/icons";
import reqwest from "reqwest";
import Filterprint from "./Filterprint";
import LoadFilter from "./LoadFilter";
import SaveFilterO from "./SaveFilterOnly";
 
const { Title } = Typography;

const { Search } = Input;
const { confirm } = Modal;
class FilterSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalVisible: this.props.modalShow,
      setIsModalVisible: this.props.modalShow,
      searchv: -2,
      showsavefilteronly:false,
      showsaveFornewScreen:false,
    };
    this.handlesave = this.handlesave.bind(this);
    this.hidecancel = this.hidecancel.bind(this);
    
  }

  componentDidMount() {

    if (this.props.datadic.FilterDic==undefined){
    this.setState({ loading: true });
    reqwest({
      url:
        this.props.apppath + "/include/api/screener/stockScreenerFilter.json",
      //url:'jlast.json',
      method: "get",
      type: "json",
    }).then((data) => {
      this.props.activateDatadic({ FilterDic: data.tables[0] });
      this.props.activateDatadicbackup({ FilterDic: data.tables[0] });
      this.setState({
        data: data.tables[0].columns,
      });
    });

  }
  }

  FilterMount() {
    this.setState({ loading: true });
    reqwest({
      url:
        this.props.apppath + "/include/api/screener/stockScreenerFilter.json",
      //url:'jlast.json',
      method: "get",
      type: "json",
    }).then((data) => {
      this.props.activateDatadic({ FilterDic: data.tables[0] });
      this.props.activateDatadicbackup({ FilterDic: data.tables[0] });
      this.setState({
        data: data.tables[0].columns,
      });
    });
  }

  showModal2 = () => {
    this.FilterMount();
    this.setState({
      setIsModalVisible: true,
      isModalVisible: true,
    });
  };

  handle() {
    this.setState({
      loading: true,
    });
    reqwest({
      url: this.props.apppath + "/include/api/screener/Simsaveload.cfm?uid="+this.props.auid,
      method: "get",
      type: "json",
    }).then((data) => {
 
this.showModal2();
      this.setState({
        data: data.results,
        loading: false,
        savefill: false,
         
      });
    });
  }


  handlesave() {
    this.setState({
      loading: true,
      savefill: true,
    });
  
    const article = {
      filter: this.props.datadic.FilterDic,
      filterName: this.props.finame,
      userId: this.props.auid,
      screenerFilterId:this.props.loadid,
    };
    axios
      .post(this.props.apppath + "/include/api/screener/SimsaveEdit.cfm", article)
      .then((response) => this.handle());
  }


    showConfirm() {
    confirm({
      title: 'Would you like to overwrite the screen you are editing?',
      icon: <ExclamationCircleOutlined />,
      content: 'This will overwrite existing screen with new filters',
      okText: 'Yes',
      cancelText: 'No',
      onOk:() => {
     this.handlesave()
      },
      onCancel:() => {

        this.props.activateLoadid('');
        this.props.activateChange('');
        this.setState({
          showsavefilteronly: true,
        
        });
        
      },
    });
  }


  showConfirmNewScreen(){
    this.props.activateLoadid('');
    this.props.activateChange('');
    this.setState({
      showsaveFornewScreen: true,
    
    });
  }

  
  fetch = (params = {}) => {
    this.setState({ loading: true });
    reqwest({
      url: "https://siproupdateonly.s3-accelerate.amazonaws.com/stockScreenerInit.json",
      method: "get",
      type: "json",
   
    }).then((data) => {
      this.props.activateStocks(data.screenRating);

      this.props.activateRecord(data.screenRating.length);
      this.props.activateFiname('');
      this.props.activateLoadid('');
      this.props.activateChange('');
      this.setState({
        loading: false,
      
      });
    });
  };

  handleCanceleditShowfilter(){
    this.FilterMount();
    this.fetch();
    this.showModalfilter();
    this.props.activateFiname('');
    this.props.activateChange('');
  }

  showModalfilter = () => {
     
    this.setState({
      setIsModalVisible: true,
      isModalVisible: true,
    });
  };


    afterSave = () => {
 
   
  };


    hidecancel = () => {
   
    this.setState({
      showsavefilteronly: false,
      showsaveFornewScreen: false,
    });
  };

  getCatNamesend(d){

    var g= '';
   
     this.props.datadic.FilterDic.groupingColumns.map((experience, i) => {
    
           if (experience.id==d){
             
             g= experience.name_
           }
     });
   
   
   
    
   return g ;
   
     }
  render() {
    var Categories = [];
    var CategoriesId = [];
    var ColTabid= [];
    var ColFid= [];
    if (this.props.datadic.FilterDic != undefined) {
      this.props.datadic.FilterDic.categories.map((experience, i) => {
        Categories[i] = this.props.datadic.FilterDic.categories[i].label;
        CategoriesId[i] = this.props.datadic.FilterDic.categories[i].id;
        ColTabid[i]=this.props.datadic.FilterDic.columns[i].tabId;
        ColFid[i]=this.props.datadic.FilterDic.columns[i].groupId;
        
      });
    }

    
    const afterSave = () => {
     
      this.setState({
        showsavefilteronly: false,
        showsaveFornewScreen:false,
      }, () => {
        this.FilterMount();
        this.fetch();
        showModal();
        
        this.props.callall();
    });
    };


    const endSafe = () => {
      this.setState({
        showsavefilteronly: false,
        showsaveFornewScreen:false,
      }, () => {
        this.FilterMount();
        this.fetch();
        showModal();
    });
    };


    
    const handleOk = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
    };

    const handleCancel = () => {
      this.setState({
        setIsModalVisible: false,
        isModalVisible: false,
      });
      this.props.handleCancel();
    };

    const showModal = () => {
      this.setState({
        setIsModalVisible: true,
        isModalVisible: true,
      });
    };


   


    const resultss = {
      display: "inline-block",
    };

    const paddingB = {};
    const setbutton = {
      marginRight: "4px",
      background:'#395dad',
      borderColor: 'rgb(57, 93, 173)',
    };

    const onSearch = (value) =>
      this.setState({
        searchv: value.target.value,
      });
    return (
      <div>
        <SaveFilterO isModalsave={this.state.showsavefilteronly}  aftersave={this.afterSave} justclose={endSafe} hidecancel={this.hidecancel} ></SaveFilterO>
        <SaveFilterO isModalsave={this.state.showsaveFornewScreen}   aftersave={this.afterSave} justclose={endSafe} hidecancel={this.hidecancel} ></SaveFilterO>


        <div>
        
      


        
        
        
          {/* {this.props.filtermt == 0 ? (
            ""
          ) : (
            <Button
            type="primary"
              icon={<PlusOutlined   ></PlusOutlined   >}
              style={setbutton}
              onClick={showModal}
              size={{ size: "large" }}
            >
              Add another filter
            </Button> 
          )}
 */}

 


         




          <LoadFilter filtermt={this.props.filtermt}></LoadFilter>
          {' '}
          <Button
            type="primary"
              icon={<FilterOutlined    ></FilterOutlined>}
              style={setbutton}
              onClick={this.props.showModal}
              size={'large'}
            >
              Add Filters
            </Button> 
        </div>

        <Modal
          title="Select Your Screening Filters"
          width={"80%"}
          style={{ top: 20 }}
          visible={this.props.isModalVisible}
          onCancel={handleCancel}
          footer={[
            <Button key="back" type="primary" onClick={handleCancel}>
              Adjust Filters
            </Button>,
          ]}
        >
          <Card bordered={true} className="cardstyle">
            

            {Categories.map((name, index) => (
              <div>
                {" "}
                <div key={CategoriesId[index]} style={paddingB}>
                  <Divider orientation="left" style={{borderTopColor:'rgb(212 212 212)'}} >
                    <b>{name} </b>
                  </Divider>
                </div>
                
                <Filterprint
                  searchv={this.state.searchv}
                  cid={CategoriesId[index]}
                ></Filterprint>
              </div>
            ))}
          </Card>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  datadic: state.datadic,
  apppath: state.apppath,
  datadicbackup: state.datadicbackup,
  finame: state.finame,
  auid: state.auid,
  loadid: state.loadid,
  record: state.record,
  change: state.change,
});

const mapDispatchToProps = {
  activateDatadic,
  activateDatadicbackup,
  activateFiname,
  activateRecord,
  activateLoadid,
  activateStocks,
  activateChange 
};

const Fselectf = connect(mapStateToProps, mapDispatchToProps)(FilterSelect);

export default Fselectf;
